export const getPlacesAutoSuggest = (lat, lng, value, cityName) => {
  return fetch(`https://places.api.here.com/places/v1/autosuggest?at=${lat},${lng}&app_id=6WEpHL1aol82fWWevOTM&app_code=6R-4NGJdzqmklqUWtF6A_g&size=1&q=${value + ', ' + cityName}`)
    .then(response => {
      if (response.ok) {
        return response.json()
      }
    }).then(response => response)
    .catch((err) => console.error(err))
}
